import { routes } from './redirectPaths';
import type { GetRedirectUrlInterface } from './types';

export function exitAppWithRedirect(to: string): void {
  try {
    window.stop();
  } catch (_) {
    document.execCommand('Stop');
  }

  window.location.href = to;
}

export function getRedirectUrl({
  rules,
  brand,
  isInWebView,
  currentPathname,
  queryString,
}: GetRedirectUrlInterface): string {
  const { isMissingRecentStrongAuth, isNotLoggedIn, isBlocked, isMissingStrongAuth, isMissingTwoFactorAuth } = rules;

  if (isNotLoggedIn()) {
    return routes.signInPage({
      brand,
      currentPathname,
      queryString,
      isInWebView,
    });
  } else if (isBlocked()) {
    // by default, do not redirect if a user is blocked
    // ...to prevent looping
    // apps should handle blocked user by
    // ... redirecting manually or showing
    // ... a UI change
    return '';
  } else if (isMissingRecentStrongAuth()) {
    return routes.signInPage({
      brand,
      currentPathname,
      queryString,
      isInWebView,
    });
  } else if (isMissingStrongAuth()) {
    return routes.passwordResetPage({
      brand,
      currentPathname,
      queryString,
      isInWebView,
    });
  } else if (isMissingTwoFactorAuth()) {
    return routes.twoFactorAuthPage({
      brand,
      currentPathname,
      queryString,
      isInWebView,
    });
  }
  return '';
}
